import styled from 'styled-components';
import BackgroundImage from 'gatsby-background-image';
import { Typography } from '@material-ui/core';
import { PRIMARY } from '../../shared/styles/colors';
import { flexBox } from '../../shared/styles/mixins';

const wrapperDefaultStyles = `
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: stretch;
  margin-top: 97px;
  
  @media (min-width: 1280px) {
    margin-top: 128px;
    min-height: 421px;
    display: flex;
    justify-content: flex-end;
  }
`;
 
export const WrapperWithBackground = styled(BackgroundImage)`
  ${wrapperDefaultStyles}
`;

export const Wrapper = styled.header`
  ${wrapperDefaultStyles}
`;

export const ContentWrapper = styled.section`
  flex: 1;
  min-width: 317px;
  align-self: flex-start;
  padding: 0 29px;

  @media (min-width: 600px) {
    padding-left: 1vw;
  }

  @media (min-width: 1024px) {
    padding-left: 3vw;
  }

  @media (min-width: 1160px) {
    padding-left: 15%;
  }
`;

export const Title = styled(Typography)`
  &.MuiTypography-h1,
  &.MuiTypography > * {
    font-size: 30px;
    font-weight: normal;
    color: ${PRIMARY};

    @media (min-width: 600px) {
      font-size: 40px;
      font-weight: 600;
    }
  }
`;

export const ImageWrapper = styled.section`
  flex: 1;
  
  .gatsby-image-wrapper {
    height: 100%;
  }
  
  @media (max-width: 600px) {
    min-width: 100%;
  }
`;

export const KnowMore = styled.button`
  position: absolute;
  bottom: 2px;
  color: white;
  width: 80px;
  height: 50px;
  left: calc(50% - 100px);
  ${flexBox('column nowrap', 'space-between')}
  cursor: pointer;
  z-index: 6;
`

export const Observation = styled.p`
  color: #B9B9B9;
  font-size: .5rem;
  margin-top: 13px;
  padding: 0 20px;
  text-align: center;
`;